<template lang="pug">
  div
    transition(name="fade" mode="out-in")
      form(v-if="!isPesquisaAvancada" key="simples")
        .container
          .item
            el-input(v-model="filtro.campoSimples" type="text" tabindex="0" :placeholder="placeholderSimples" clearable)
              el-button(
                slot="append",
                icon="el-icon-search",
                @click="pesquisarSimples"
              )

      form(v-if="isPesquisaAvancada" key="avancado")
        .container
          .item(v-for="(input, index) in jsonFiltro")
            p {{ input.rotulo }}

            //- Inputs normais
            el-input(v-if="input.tipo === 'text'" v-model="filtro[input.propriedade]" :type="input.tipo" :tabindex="index.toString()" clearable)

            //- Selects
            el-select(
              v-if="input.tipo === 'select'"
              multiple
              collapse-tags
              v-model="filtro[input.propriedade]"
              :tabindex="index.toString()"
              clearable
              filterable
            ).width-100
              el-option(
                v-for="option in input.opcoes"
                :key="option.valor"
                :label="option.rotulo"
                :value="option.valor"
                value-key="label"
              )

            //- Datas
            el-date-picker(
              v-if="['daterange', 'dates'].includes(input.tipo)"
              v-model="filtro[input.propriedade]"
              :type="input.tipo"
              align="right"
              start-placeholder="Data inicial"
              end-placeholder="Data Final"
              format="dd/MM/yyyy"
              :tabindex="index.toString()"
              clearable
            ).width-100

          .item
          .item
    div.button-group(v-if="hasButtonLimpar")
      div
        transition(name="fade" mode="out-in")
        el-button(@click="limparCampos").button Limpar

    div.button-group(v-if="hasButtonsPesquisaAvancada")
      div
        transition(name="fade" mode="out-in")
          el-button(v-if="!isPesquisaAvancada" @click="isPesquisaAvancada = true" key="avancada-botao").button Pesquisa avançada
          el-button(v-if="isPesquisaAvancada" @click="isPesquisaAvancada = false" key="simples-botao").button Pesquisa simplificada
        el-button(@click="limparCampos").button Limpar
      el-button(@click="pesquisarAvancado" v-if="isPesquisaAvancada" size="medium" icon="el-icon-search") Pesquisar
</template>

<script>
import FILTRO_EMPTY from '@/models/filtro'

export default {
  data () {
    return {
      filtro: FILTRO_EMPTY(),
      inputs: [],
      isPesquisaAvancada: false,
      timerFuncaoDebounce: null,
      delayDebounce: 500
    }
  },

  props: {
    hasButtonsPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    placeholderSimples: {
      type: String,
      default: ''
    },
    hasButtonLimpar: {
      type: Boolean,
      default: false
    },
    /**
      * Json com as informacões do header
      */
    jsonFiltro: {
      type: Array,
      required: false,
      default: function () {
        return [ { id: 0, rotulo: 'Processo', propriedade: 'processo', tipo: 'text' },
          { id: 1, rotulo: 'Oi', propriedade: 'cpfCnpjInteressado', tipo: 'text' },
          { id: 2, rotulo: 'Data de vencimento', propriedade: 'nomeRazaoInteressado', tipo: 'daterange' },
          { id: 3, rotulo: 'Data de vencimento', propriedade: 'situacao', tipo: 'text' },
          { id: 4, rotulo: 'Data de vencimento', propriedade: 'dataVencimento', tipo: 'text' },
          { id: 5, rotulo: 'Data de vencimento', propriedade: 'responsavel', tipo: 'dates' },
          { id: 6, rotulo: 'Data de vencimento', propriedade: 'titulo', tipo: 'text' },
          { id: 7, rotulo: 'Data de vencimento', propriedade: 'municipio', tipo: 'text' },
          { id: 8, rotulo: 'Data de vencimento', propriedade: 'ordemServico', tipo: 'text' },
          { id: 9, rotulo: 'Data de vencimento', propriedade: 'statusOrdemServico', tipo: 'text' },
          { id: 10, rotulo: 'Data de vencimento', propriedade: 'funcao', tipo: 'text' },
          { id: 11, rotulo: 'Data de vencimento', propriedade: 'periodo', tipo: 'text' },
          { id: 13,
            rotulo: 'Receitas',
            propriedade: 'receitas',
            tipo: 'select',
            options: [
              { value: 1, rotulo: 'Oi' },
              { value: 2, rotulo: 'Ola' }
            ]
          }
        ]
      }
    }
  },

  methods: {
    pesquisarSimples () {
      return this.$emit('pesquisar', this.filtro)
    },

    pesquisarAvancado () {
      return this.$emit('pesquisar', this.filtro)
    },

    limparCampos () {
      this.filtro = FILTRO_EMPTY()
      return this.$emit('limparCampos', this.filtro)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.container {
  display: flex;
  flex-wrap: wrap;
}

.item {
  flex-grow: 1;
  flex-basis: 400px;
  margin: 10px;
}

.width-100 {
  width: 100%
}

/deep/ .el-tag.el-tag--info {
  color: #009f61;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin: 10px;
}

.button {
  border: none;
  background: none;
  padding: 0;
  color:#009f61;
}

.button:hover {
  color:#2e7a5c;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/deep/ .el-icon-search {
  color: #009f61;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFiltro.vue